<template>
  <b-field
    :type="type"
    :message="message"
		:custom-class="customClass">
    <template v-if="label" #label>
      <qd-label :label="label" :required="required" />
    </template>
    <b-autocomplete
      :value="name"
      icon="magnify"
      :open-on-focus="openOnFocus"
      :data="filteredItems"
      :field="field"
      :placeholder="placeholder"
      :loading="isFetching"
      :disabled="disabled"
      :clearable="clearable"
      :expanded="expanded"
      @input="setName"
      @select="select">
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
      <template #header>
        <a v-if="create" class="is-underline" @click="openPopUpAdd = true">
          {{ $t(`parametre.${target}.titleCreate`) }}
        </a>
      </template>
      <template #empty>
        <div v-if="!isFetching">
          {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>
          {{$t('general.autocomplete.search')}}
        </div>
      </template>
    </b-autocomplete>
    <b-modal :active.sync="openPopUpAdd" :width="640" scroll="keep">
      <modal-creer-parametre
        :target="target"
        :libelle-value="name"
        @reloadParametrage="loadItems"
        @close="openPopUpAdd = false"/>
    </b-modal>
  </b-field>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import QdLabel from '@/components/general/qdLabel.vue';
import ModalCreerParametre from '@/views/recommandations/modalCreerParametre.vue';

const Parametres = createNamespacedHelpers('parametrage');

export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    target: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: false,
      default: 'libelle',
    },
    selector: {
      type: String,
      required: false,
      default: 'id',
    },
    openOnFocus: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Function,
      required: false,
      default: null,
    },
    customMapItem: {
      type: Function,
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    create: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
	customClass: {
    type: String,
    required: false,
    default: '',
  },
  },
  components: {
    QdLabel,
    ModalCreerParametre,
  },
  data() {
    return {
      items: [],
      isFetching: false,
      openPopUpAdd: false,
      name: '',
    };
  },
	watch: {
		value(newValue) {
			const existingItem = this.items.find(i => i[this.selector] === newValue);
			this.name = existingItem ? existingItem[this.field] : '';
		},
	},
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    filteredItems() {
      const nameVal = this.name ? this.name.trim().toLowerCase() : '';
      return this.items.filter(item => {
        return (this.selected === item.id || item.actif)
        && (nameVal === '' || item[this.field].toLowerCase().includes(nameVal))
        && (this.query ? this.query(item) : true);
      });
    },
    currentItem() {
      return this.items.find(i => i[this.selector] === this.selected);
    },
    message() {
      return (this.currentItem && !this.currentItem.actif) ? this.$t('general.messages.warning.archive') : '';
    },
    type() {
      if (this.error) return 'is-danger';
      return (this.currentItem && !this.currentItem.actif) ? 'is-warning' : '';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    setName(value) {
      const existingItem = this.items.find(i => i[this.field] === value);
      if (!existingItem) this.selected = null;
      this.name = value;
    },
    select(value) {
      this.$emit('select', value);
      if (!value) {
        this.selected = null;
        return;
      }
      this.selected = value[this.selector];
      this.name = value[this.field];
    },
    async loadItems(item) {
      try {
        await this.loadParametres([this.target]);
        if (this.customMapItem) {
          this.items = this.parametre(this.target).map(this.customMapItem);
        } else {
          this.items = this.parametre(this.target);
        }
        if (item) this.select(item);

        // en attendant que l'archivage arrive sur tous les cas d'utilisation
        this.items.forEach(i => {
          if (i.actif === undefined) i.actif = true;
        });
      } catch (error) {
        gestionErreur(this.$i18n.t('general.validation.error'), error);
        throw error;
      } finally {
        this.isFetching = false;
      }
    }
  },
  async mounted() {
    await this.loadItems();
    this.name = this.currentItem ? this.currentItem[this.field] : '';
  },
};
</script>
